// extracted by mini-css-extract-plugin
export default {"orderContainer":"ReorderableList-module__orderContainer--tpPRs","draggableContainer":"ReorderableList-module__draggableContainer--eu8Ej"};